import type { FC, PropsWithChildren } from "react";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

import {
    StyledHeaderContainer,
    StyledHeaderContent,
    StyledHeaderContentWrapper,
    StyledHeaderDescription,
    StyledHeaderTitle,
} from "./styles";

type ListPageHeaderProps = {
    title: Readonly<Translatable>;
    description: Readonly<Translatable>;
};

const ListPageHeader: FC<PropsWithChildren<ListPageHeaderProps>> = ({ title, description, children }) => {
    return (
        <StyledHeaderContainer>
            <StyledHeaderContentWrapper>
                <I18n
                    translatable={title}
                    element={StyledHeaderTitle}
                />
                <StyledHeaderContent>
                    <I18n
                        translatable={description}
                        element={StyledHeaderDescription}
                    />
                </StyledHeaderContent>
                {children}
            </StyledHeaderContentWrapper>
        </StyledHeaderContainer>
    );
};

export default ListPageHeader;
